/* GALOBART Home — minimal progressive enhancement.
   Reveal-on-scroll via IntersectionObserver. No dependencies.
   Degrades gracefully: if JS/observer is unavailable, CSS falls
   back to visible content (see .no-js handling below). */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal() {
    var nodes = document.querySelectorAll(".tgb-reveal:not(.is-in)");
    if (!nodes.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          obs.unobserve(e.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function carousels() {
    document.querySelectorAll("[data-tgb-carousel]").forEach(function (wrap) {
      if (wrap.__tgbInit) return;
      wrap.__tgbInit = true;
      var track = wrap.querySelector(".tgb-carousel");
      var prev = wrap.querySelector("[data-tgb-prev]");
      var next = wrap.querySelector("[data-tgb-next]");
      if (!track) return;
      function step() { var c = track.querySelector(":scope > *"); return c ? c.getBoundingClientRect().width + 24 : 320; }
      function upd() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step() * 2, behavior: "smooth" }); });
      track.addEventListener("scroll", upd, { passive: true });
      upd();
    });
  }

  function init() { reveal(); carousels(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // Re-scan when sections are edited in the theme editor.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", init);
  }
})();
